// extracted by mini-css-extract-plugin
module.exports = {"background":"unitView_background__2Alz9"};
    if(module.hot) {
      // 1790670302372
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  